<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.43923 16.4972C9.4779 16.8066 9.67127 17 10.0193 17C10.2901 17 10.5028 16.8066 10.5608 16.5166C11.4116 12.1657 11.9917 11.2182 16.4972 10.5608C16.8066 10.5221 17 10.2901 17 10.0193C17 9.70995 16.8066 9.4779 16.4972 9.43923C11.9917 8.78177 11.2182 7.73757 10.5608 3.5221C10.5028 3.19337 10.2901 3 10.0193 3C9.70995 3 9.49724 3.19337 9.43923 3.50276C8.5884 7.81492 8.00829 8.78177 3.5221 9.43923C3.19337 9.4779 3 9.70995 3 10.0193C3 10.2901 3.19337 10.5028 3.5221 10.5608C8.00829 11.2182 8.76243 12.1657 9.43923 16.4972Z"
      fill="currentColor"
    />
  </svg>
</template>
